import { createFileRoute } from "@tanstack/react-router";
import { ScheduleTable } from "@/components/admin/schedule-table";

export const Route = createFileRoute("/_auth/app/admin/schedule")({
  component: SchedulePage,
});

function SchedulePage() {
  return <ScheduleTable />;
}
